var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#B0C5C8}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_651526016"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7999976 8612697c-459366,0 -831910,372378 -831910,831910 0,308055 167953,576378 416918,720284l0 924863 829985 -12 0 -924863c248965,-143847 416906,-412217 416906,-720284 0,-459520 -372473,-831898 -831898,-831898z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M8000295 4578711c-699272,0 -1268020,568807 -1268020,1268020l0 1350367 2535934 0 0 -1350367c-59,-699107 -568807,-1268020 -1267914,-1268020z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7999870 71c-4418152,0 -7999870,3581825 -7999870,7999976 0,4418045 3581718,7999976 7999870,7999976 4418152,0 8000142,-3581978 8000142,-7999976 -12,-4418152 -3581990,-7999976 -8000142,-7999976zm2458171 12113108l-4915975 0c-519154,0 -940075,-420910 -940075,-940229l0 -3035730c0,-452858 320386,-831059 746847,-920020l0 -1370528c0,-1461827 1189359,-2651293 2651304,-2651293 1461827,0 2651186,1189359 2651186,2651293l0 1370528c426307,89232 746681,467162 746681,920020l0 3035730 106 0c0,519260 -420921,940229 -940075,940229z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.257422f79db2c576a68e2e52488b6fc4.svg";
export { ForwardRef as ReactComponent };